export class Image {
  $key: string;
  file: File;
  description: string;
  url: string;
  progress: number;
  constructor(file: File) {
    this.file = file;
  }
}


// WEBPACK FOOTER //
// C:/Users/Jeremy/Desktop/EFA/jerusalem-temple/src/app/services/image.model.ts